/* PureTech theme JS */
(function () {
  'use strict';

  /* Mobile nav */
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Product gallery thumbs */
  var mainBtn = document.querySelector('[data-gallery-main]');
  var mainImg = mainBtn ? mainBtn.querySelector('img') : null;
  var thumbs = document.querySelectorAll('[data-gallery-thumb]');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = t.dataset.src;
      mainImg.srcset = '';
      if (mainBtn) mainBtn.dataset.zoomSrc = t.dataset.zoomSrc || t.dataset.src;
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  /* Gallery lightbox */
  var lightbox = document.querySelector('[data-lightbox]');
  var lightboxImg = document.querySelector('[data-lightbox-img]');
  if (lightbox && lightboxImg && mainBtn) {
    /* escape the page's stacking contexts so the overlay covers the sticky header */
    document.body.appendChild(lightbox);
    var openLightbox = function () {
      var src = mainBtn.dataset.zoomSrc || (mainImg && mainImg.src);
      if (!src) return;
      lightboxImg.src = src;
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    };
    var closeLightbox = function () {
      lightbox.hidden = true;
      document.body.style.overflow = '';
    };
    mainBtn.addEventListener('click', openLightbox);
    lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (el) {
      el.addEventListener('click', closeLightbox);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lightbox.hidden) closeLightbox();
    });
  }

  /* Variant select -> price update */
  var variantSelect = document.querySelector('[data-variant-select]');
  var priceEl = document.querySelector('[data-price]');
  if (variantSelect && priceEl) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
    });
  }

  /* Scroll reveal */
  if ('IntersectionObserver' in window) {
    var revealEls = document.querySelectorAll(
      '.rail__head, .rail-step, .featured__head, .product-card, .trust .center, .trust-card, .cta-band .wrap, .faq details, .pinfo h1, .pinfo__price, .pinfo__desc, .pinfo form, .specs'
    );
    revealEls.forEach(function (el) {
      var i = 0;
      var prev = el.previousElementSibling;
      while (prev) { if (prev.classList.contains('reveal')) i++; prev = prev.previousElementSibling; }
      el.style.transitionDelay = Math.min(i, 5) * 90 + 'ms';
      el.classList.add('reveal');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal--in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -36px' });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  /* App picker: standard tiles + "Add apps" popup (approved add-ons + Play catalog search) */
  var picker = document.querySelector('[data-app-picker]');
  if (picker) {
    var countEl = picker.querySelector('[data-app-count]');
    var doneCount = picker.querySelector('[data-addon-count]');
    var modal = picker.querySelector('[data-addon-modal]');
    var search = picker.querySelector('[data-app-search]');
    var emptyMsg = picker.querySelector('[data-app-empty]');
    var addonSec = picker.querySelector('[data-addon-section]');
    var addonGrid = picker.querySelector('[data-addon-grid]');
    var resultsSec = picker.querySelector('[data-play-results]');
    var resultsGrid = resultsSec ? resultsSec.querySelector('.app-grid') : null;
    var addedSec = picker.querySelector('[data-added-section]');
    var chipsWrap = picker.querySelector('[data-added-chips]');
    var whatsappBlocks = picker.querySelector('[data-whatsapp-blocks]');
    var addons = null;
    var catalog = null;

    var checkSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l5 5 9-11"/></svg>';

    /* Never offer these from the app-store catalog: social media, dating,
       browsers, streaming, filter-bypass. (The approved add-on list is curated
       by hand and not subject to this guard.) */
    var denied = /browser|dating|tiktok|tik tok|instagram|threads|snapchat|twitter|facebook|messenger|youtube|telegram|discord|reddit|pinterest|tumblr|twitch|bereal|lemon8|wechat|weibo|tinder|bumble|hinge|badoo|okcupid|grindr|netflix|hulu|hbo|disney\+|paramount|peacock|prime video|onlyfans|vpn|proxy|incognito|adult/i;

    /* Apps the current phone model can't run (set per-product in liquid) */
    var unsupported = (picker.dataset.unsupported || '')
      .split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    function isUnsupported(title) {
      var t = title.toLowerCase();
      return unsupported.some(function (u) {
        var esc = u.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        return new RegExp('\\b' + esc + '\\b').test(t);
      });
    }

    var stdSection = picker.querySelector('[data-app-section]');

    /* Extra-app fee rule: the first N add-on apps are included, then $X each */
    var freeExtras = parseInt(picker.dataset.freeExtras || '15', 10);
    var feeDollars = parseFloat(picker.dataset.feeDollars || '2');
    var feeVariant = picker.dataset.feeVariant || '';
    var feeNote = picker.querySelector('[data-fee-note]');
    var feeNoteDefault = feeNote ? feeNote.textContent : '';

    function extraBoxes() {
      return addonGrid
        ? addonGrid.querySelectorAll('input[name="properties[Apps][]"]:checked')
        : [];
    }

    function updateFeeNote() {
      if (!feeNote) return;
      var n = extraBoxes().length;
      var over = n - freeExtras;
      feeNote.classList.toggle('is-over', over > 0);
      if (n === 0) {
        feeNote.textContent = feeNoteDefault;
      } else if (over > 0) {
        feeNote.textContent = n + ' add-on apps picked — ' + freeExtras + ' are included, so ' +
          over + ' × $' + feeDollars + ' = $' + (over * feeDollars) + ' extra (added in your cart).';
      } else if (n === freeExtras) {
        feeNote.textContent = 'All ' + freeExtras + ' included add-on apps used — each app from here is $' + feeDollars + '.';
      } else {
        feeNote.textContent = n + ' of ' + freeExtras + ' included add-on apps used.';
      }
    }

    /* WhatsApp's Status/Channels blocks only make sense once WhatsApp is actually
       in the order, so that section stays hidden (and unchecked) until then */
    function updateWhatsappBlocks() {
      if (!whatsappBlocks) return;
      var hasWhatsapp = Array.prototype.some.call(
        picker.querySelectorAll('[data-app-tile]'),
        function (tile) {
          var box = tile.querySelector('input[name="properties[Apps][]"]');
          return box && box.checked &&
            (tile.dataset.pkg === 'com.whatsapp' || (tile.dataset.appName || '').indexOf('whatsapp') !== -1);
        }
      );
      whatsappBlocks.hidden = !hasWhatsapp;
      if (!hasWhatsapp) {
        whatsappBlocks.querySelectorAll('input[type="checkbox"]').forEach(function (b) { b.checked = false; });
      }
    }

    var update = function () {
      var std = stdSection ? stdSection.querySelectorAll('input[name="properties[Apps][]"]:checked').length : 0;
      var n = std + extraBoxes().length;
      if (countEl) countEl.textContent = n + (n === 1 ? ' app selected' : ' apps selected');
      if (doneCount && addonGrid) {
        var a = addonGrid.querySelectorAll('input:checked').length;
        doneCount.textContent = a ? ' — ' + a + ' added' : '';
      }
      updateFeeNote();
      updateWhatsappBlocks();
    };
    picker.addEventListener('change', function () { update(); syncChips(); });
    update();

    /* checked state on the pre-rendered standard tiles */
    picker.querySelectorAll('[data-app-tile]').forEach(function (tile) {
      var box = tile.querySelector('input[type="checkbox"]');
      if (!box) return;
      var sync = function () { tile.classList.toggle('is-checked', box.checked); };
      box.addEventListener('change', sync);
      sync();
    });

    /* A default app's short display name sometimes corresponds to one specific
       real Play Store listing with a fuller title (e.g. the default "Weather"
       tile is Breezy Weather) — treat that listing as already taken too, so it
       doesn't show up as a separate (fee-counted) search result. Curated by
       hand on purpose: a generic prefix/contains match here would also hide
       genuinely different apps that happen to share a word, e.g. "Uber Eats"
       is not the same app as the default "Uber", nor is "Phone Tracker" the
       same as the default "Phone". */
    var DEFAULT_APP_ALIASES = {
      'sms backup': ['sms backup & restore'],
      'weather': ['breezy weather'],
    };

    function takenNames() {
      var names = {};
      var pkgs = {};
      [picker, modal].forEach(function (root) {
        if (!root) return;
        root.querySelectorAll('[data-app-tile]').forEach(function (t) {
          var n = t.dataset.appName;
          names[n] = 1;
          (DEFAULT_APP_ALIASES[n] || []).forEach(function (alias) { names[alias] = 1; });
          if (t.dataset.pkg) pkgs[t.dataset.pkg] = 1;
        });
      });
      return { names: names, pkgs: pkgs };
    }

    /* Build a tappable tile; app = { t, p, icon } */
    function makeTile(app, isResult) {
      var na = isUnsupported(app.t);
      var li = document.createElement('li');
      li.className = 'app-tile' + (isResult ? ' app-tile--result' : '') + (na ? ' app-tile--na' : '');
      li.setAttribute('data-app-tile', '');
      li.dataset.appName = app.t.toLowerCase();
      if (app.p) li.dataset.pkg = app.p;
      if (app.icon) li.dataset.icon = app.icon;
      var label = document.createElement('label');
      var input = document.createElement('input');
      input.type = 'checkbox';
      input.name = 'properties[Apps][]';
      input.value = app.p ? app.t + ' (' + app.p + ')' : app.t;
      if (app.icon) {
        var img = document.createElement('img');
        img.className = 'app-tile__img';
        img.width = 48; img.height = 48; img.alt = ''; img.loading = 'lazy';
        img.src = app.icon;
        img.addEventListener('error', function () {
          delete li.dataset.icon;
          var mono = document.createElement('span');
          mono.className = 'app-tile__mono';
          mono.textContent = app.t.charAt(0).toUpperCase();
          img.replaceWith(mono);
        });
        label.appendChild(input);
        label.appendChild(img);
      } else {
        var mono2 = document.createElement('span');
        mono2.className = 'app-tile__mono';
        mono2.textContent = app.t.charAt(0).toUpperCase();
        label.appendChild(input);
        label.appendChild(mono2);
      }
      var name = document.createElement('span');
      name.className = 'app-tile__name';
      name.textContent = app.t;
      if (na) {
        input.disabled = true;
        li.title = 'Not supported on this phone model';
        var naTag = document.createElement('span');
        naTag.className = 'app-tile__na';
        naTag.textContent = 'Not supported on this model';
        name.appendChild(naTag);
      }
      var check = document.createElement('span');
      check.className = 'app-tile__check';
      check.setAttribute('aria-hidden', 'true');
      check.innerHTML = checkSvg;
      label.appendChild(name);
      label.appendChild(check);
      li.appendChild(label);
      input.addEventListener('change', function () {
        li.classList.toggle('is-checked', input.checked);
        /* a tapped Play result becomes a regular add-on tile so it survives new searches */
        if (input.checked && li.classList.contains('app-tile--result') && addonGrid) {
          li.classList.remove('app-tile--result');
          addonGrid.insertBefore(li, addonGrid.firstChild);
          filter();
        }
      });
      return li;
    }

    /* "Your added apps" chips on the page mirror the checked popup tiles */
    function syncChips() {
      if (!chipsWrap || !addonGrid) return;
      chipsWrap.innerHTML = '';
      var n = 0;
      addonGrid.querySelectorAll('[data-app-tile]').forEach(function (tile) {
        var box = tile.querySelector('input');
        if (!box || !box.checked) return;
        n++;
        var chip = document.createElement('span');
        chip.className = 'chip';
        if (tile.dataset.icon) {
          var img = document.createElement('img');
          img.className = 'chip__img';
          img.width = 22; img.height = 22; img.alt = '';
          img.src = tile.dataset.icon;
          chip.appendChild(img);
        } else {
          var mono = document.createElement('span');
          mono.className = 'chip__mono';
          mono.textContent = tile.dataset.appName.charAt(0).toUpperCase();
          chip.appendChild(mono);
        }
        var nm = document.createElement('span');
        nm.textContent = tile.querySelector('.app-tile__name').childNodes[0].textContent;
        chip.appendChild(nm);
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'chip__x';
        x.setAttribute('aria-label', 'Remove');
        x.textContent = '×';
        x.addEventListener('click', function () {
          box.checked = false;
          box.dispatchEvent(new Event('change', { bubbles: true }));
        });
        chip.appendChild(x);
        chipsWrap.appendChild(chip);
      });
      if (addedSec) addedSec.hidden = n === 0;
    }

    function loadAddons() {
      if (addons !== null || !addonGrid) return;
      addons = [];
      fetch(picker.dataset.addonUrl)
        .then(function (r) { return r.json(); })
        .then(function (j) {
          addons = j;
          var have = takenNames();
          j.forEach(function (a) {
            if (have.names[a.t.toLowerCase()]) return;
            addonGrid.appendChild(makeTile({
              t: a.t,
              p: a.p,
              icon: a.i ? 'https://play-lh.googleusercontent.com/' + a.i + '=s96' : null,
            }, false));
          });
        })
        .catch(function () { addons = []; });
    }

    function loadPlayCatalog() {
      if (catalog !== null || !picker.dataset.catalogUrl) return;
      catalog = [];
      fetch(picker.dataset.catalogUrl)
        .then(function (r) { return r.json(); })
        .then(function (j) { catalog = j; if (search && search.value.trim()) filter(); })
        .catch(function () { catalog = []; });
    }

    function renderResults(q) {
      if (!resultsGrid) return 0;
      resultsGrid.innerHTML = '';
      if (!catalog || !catalog.length || q.length < 2) { resultsSec.hidden = true; return 0; }
      var have = takenNames();
      var shown = 0;
      for (var k = 0; k < catalog.length && shown < 18; k++) {
        var a = catalog[k];
        var lower = a.t.toLowerCase();
        if (lower.indexOf(q) === -1 || have.names[lower]) continue;
        if (a.p && have.pkgs[a.p]) continue;
        if (denied.test(a.t) || denied.test(a.p || '')) continue;
        resultsGrid.appendChild(makeTile({
          t: a.t, p: a.p,
          icon: 'https://play-lh.googleusercontent.com/' + a.i + '=s96',
        }, true));
        shown++;
      }
      resultsSec.hidden = shown === 0;
      return shown;
    }

    function filter() {
      var q = search ? search.value.trim().toLowerCase() : '';
      var visible = 0;
      if (addonGrid) {
        addonGrid.querySelectorAll('[data-app-tile]').forEach(function (tile) {
          var hit = !q || tile.dataset.appName.indexOf(q) !== -1;
          tile.classList.toggle('is-hidden', !hit);
          if (hit) visible++;
        });
        if (addonSec) addonSec.style.display = visible ? '' : 'none';
      }
      var playShown = renderResults(q);
      if (emptyMsg) emptyMsg.hidden = !q || (visible + playShown) !== 0;
    }

    /* Popup open/close */
    function openModal() {
      if (!modal) return;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      loadAddons();
      loadPlayCatalog();
      if (search) search.focus();
    }
    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.body.style.overflow = '';
    }
    picker.querySelectorAll('[data-addon-open]').forEach(function (b) { b.addEventListener('click', openModal); });
    picker.querySelectorAll('[data-addon-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    if (search) search.addEventListener('input', filter);

    /* On add-to-cart: submit a readable summary instead of the raw 25+ app list —
       "Standard apps: All included / All except: …" plus "Extra apps: …".
       If more add-ons were picked than the included amount, the $2-per-app fee
       item is added to the cart alongside the phone. */
    var form = picker.closest('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        var allAppBoxes = picker.querySelectorAll('input[name="properties[Apps][]"]');
        var removed = [];
        if (stdSection) {
          stdSection.querySelectorAll('input[name="properties[Apps][]"]').forEach(function (b) {
            if (!b.checked) removed.push(b.value);
          });
        }
        var extras = [];
        extraBoxes().forEach(function (b) { extras.push(b.value); });

        form.querySelectorAll('input[data-app-summary]').forEach(function (el) { el.remove(); });
        var addHidden = function (name, value) {
          var el = document.createElement('input');
          el.type = 'hidden';
          el.name = name;
          el.value = value;
          el.setAttribute('data-app-summary', '');
          form.appendChild(el);
        };
        if (removed.length) {
          addHidden('properties[Standard apps]', 'All included except the ones below');
          removed.forEach(function (app, i) { addHidden('properties[Removed standard app ' + (i + 1) + ']', app); });
        } else {
          addHidden('properties[Standard apps]', 'All included');
        }
        extras.forEach(function (app, i) { addHidden('properties[Extra app ' + (i + 1) + ']', app); });

        allAppBoxes.forEach(function (b) { b.disabled = true; });

        var over = extras.length - freeExtras;
        if (over > 0 && feeVariant) {
          e.preventDefault();
          var fd = new FormData(form);
          allAppBoxes.forEach(function (b) { if (!b.closest('.app-tile--na')) b.disabled = false; });
          fetch('/cart/add.js', { method: 'POST', body: fd })
            .then(function (r) {
              if (!r.ok) throw new Error('add failed');
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: Number(feeVariant),
                  quantity: over,
                  properties: { 'Covers': over + ' add-on app' + (over === 1 ? '' : 's') + ' beyond the ' + freeExtras + ' included' },
                }),
              });
            })
            .then(function () { window.location.href = '/cart'; })
            .catch(function () { window.location.href = '/cart'; });
        }
      });
    }

    /* The popup must escape the page's stacking contexts to cover the sticky
       header. Its checkboxes leave the form, but selections are submitted via
       the summary fields built above. */
    if (modal) {
      document.body.appendChild(modal);
      modal.addEventListener('change', function () { update(); syncChips(); });
    }
  }

  /* Simpler products (like the Waze device) submit plain checkbox lists —
     apps and add-ons — with no app-picker JS of their own. Shopify joins
     repeated properties[X][] into one comma-packed line, so split each
     group into one property per item here, same as the phone app picker
     does. Skipped on picker forms, which already handle properties[Apps][]
     themselves. */
  function bindArraySplit(form, groupName, singularLabel) {
    var selector = 'input[name="properties[' + groupName + '][]"]';
    if (!form.querySelector(selector)) return;
    form.addEventListener('submit', function () {
      var boxes = form.querySelectorAll(selector);
      form.querySelectorAll('input[data-split-summary="' + groupName + '"]').forEach(function (el) { el.remove(); });
      var i = 0;
      boxes.forEach(function (b) {
        if (!b.checked) return;
        i += 1;
        var el = document.createElement('input');
        el.type = 'hidden';
        el.name = 'properties[' + singularLabel + ' ' + i + ']';
        el.value = b.value;
        el.setAttribute('data-split-summary', groupName);
        form.appendChild(el);
      });
      boxes.forEach(function (b) { b.disabled = true; });
    });
  }
  document.querySelectorAll('form').forEach(function (form) {
    if (form.dataset.arraySplitBound || form.closest('[data-app-picker]') || form.querySelector('[data-app-picker]')) return;
    form.dataset.arraySplitBound = 'true';
    bindArraySplit(form, 'Add-ons', 'Add-on');
    bindArraySplit(form, 'Apps', 'App');
  });
})();

(function () {
  document.querySelectorAll('[data-upsell-add]').forEach(function (button) {
    button.addEventListener('click', function () {
      button.disabled = true;
      button.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: button.dataset.variantId, quantity: 1 }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          window.location.reload();
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = 'Add to cart';
        });
    });
  });
})();
